import {
    Component,
    OnInit,
    inject,
    ChangeDetectionStrategy,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { environment } from '../environments/environments';
import { ConfirmationModalComponent } from './shared/confirmation-modal/confirmation-modal.component';
import { JustificationModalComponent } from './shared/justification-modal/justification-modal.component';
import { ToastComponent } from './shared/toast/toast.component';
import { UpdateService } from './core/services/update/update.service';

@Component({
    selector: 'app-root',
    imports: [
        RouterModule,
        CommonModule,
        ConfirmationModalComponent,
        JustificationModalComponent,
        ToastComponent,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
    private updateService = inject(UpdateService);

    title = 'presences-management';
    env = environment;

    ngOnInit(): void {
        // Initialize update service to listen for app updates
        this.updateService.initialize();
    }
}
